import { Navigate } from "react-router-dom";

import { getInstCodeFromScopes } from "../lib/oauthHelper";
import { withAuthProps } from "../withAuth";
import { DisabledTenantWithWrapper } from "../DisabledTenant";

interface RedirectToSageOrHomeProps extends withAuthProps {
  scopes: Array<string>;
}

const RedirectToSageOrHome = ({
  scopes,
}: RedirectToSageOrHomeProps): JSX.Element => {
  const instCode = getInstCodeFromScopes(scopes);

  if (instCode) {
    return <Navigate to={`/${instCode}/books`} />;
  }

  return <DisabledTenantWithWrapper />;
};

export default RedirectToSageOrHome;
